module.exports = (__webpack_require__(0))(15);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/UserModel.js from dll-reference girder_lib
// module id = 78
// module chunks = 0